import { AnyAction } from 'redux';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import clipArtCategoryToAddonCategory from 'src/util/addon/clipArtCategoryToAddonCategory';
import getPrice from 'src/store/price/selector/getPrice';
import getCategoryId from 'src/store/design/selector/getCategoryId';
import formatPrice from 'src/util/price/formatPrice';
import productPriceToPrice from 'src/util/price/productPriceToPrice';
import getCurrencyId from 'src/store/price/selector/getCurrencyId';
import getPriceFormat from 'src/store/price/selector/getPriceFormat';
import getClipartSearchString from '../selector/getClipartSearchString';
import { IClipArtResultCategory } from '../types/clipArtTypes';

/**
 * Send only the NEW subcategories to the editor for appending
 * @param newSubcategories - Only the newly loaded subcategories (not the full accumulated list)
 * @param hasMore - Whether there are more categories to load
 * @param requestVersion - Version number for the request
 */
const sendClipArtCategoryAppendPostMessageOperation = (
  newSubcategories: IClipArtResultCategory[],
  hasMore: boolean,
  requestVersion = 0,
) => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  const store = getState();
  const categoryId = getCategoryId(store);

  const currencyId = getCurrencyId(store) || '';
  const priceFormat = getPriceFormat(store) || '';

  const getAddonPrice = (productId: number) => {
    const priceObj = getPrice(store, categoryId || 1, productId, 1);
    if (!priceObj) {
      return '';
    }
    return formatPrice(productPriceToPrice(priceObj).price, priceFormat, currencyId);
  };

  // Create a temporary category structure with only the new subcategories
  // Use '0' as root category ID to match ROOT_CATEGORY_ID in fetchClipArtCategoryOperation
  const appendCategory: IClipArtResultCategory = {
    clipArtCategoryId: '0',
    title: 'Cliparts',
    clipArts: [],
    subCategories: newSubcategories,
    clipArtsLoaded: true,
    imageUrl: '',
    parentClipArtCategoryId: null,
    hasMore,
  };

  sendPostMessage({
    type: MESSAGE_TYPE['addons.appendAddons'],
    data: {
      search: {
        value: getClipartSearchString(store),
        recent: [],
      },
      categoryId: null, // Root level append
      resultsVersion: requestVersion,
      results: {
        category: clipArtCategoryToAddonCategory(
          appendCategory,
          null,
          getAddonPrice,
        ),
        elements: undefined,
      },
      more: hasMore,
    },
  });
};

export default sendClipArtCategoryAppendPostMessageOperation;
